import type { ComputedRef } from "vue";
import type { WebsitePageFragment } from "~/graphql/generated";

type MetaTitle = string;
type MetaDescription = string;
type Description = string;

type MetaFallback = {
  metaTitle: ComputedRef<MetaTitle | undefined>;
  metaDescription: ComputedRef<MetaDescription | undefined>;
  description: ComputedRef<Description | undefined>;
};

/**
 * Lets a linked website (CMS) page's own meta/content take priority over an
 * entity's (shop/brand/category/...) meta, falling back to the entity's
 * values when no website page is linked or it has nothing set.
 */
export default function useContentPageMeta(
  websitePage: ComputedRef<WebsitePageFragment | undefined>,
  fallback: MetaFallback,
) {
  const metaTitle = computed(
    () => websitePage.value?.metaTitle || fallback.metaTitle.value,
  );
  const metaDescription = computed(
    () => websitePage.value?.metaDescription || fallback.metaDescription.value,
  );
  const seoDescription = computed(
    () => websitePage.value?.content || fallback.description.value || "",
  );

  return { metaTitle, metaDescription, seoDescription };
}
